import * as React from 'react'

const Exclude = (props: { className?: string }) => {
  return (
    <svg
      className={props.className}
      width='14'
      height='16'
      viewBox='0 0 14 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M1 14.2227C1 15.2002 1.90039 16 3 16H10.999C12.0996 16 12.999 15.2002 12.999 14.2227V3.55566H1V14.2227ZM13.999 0.888672H10.499L9.5 0H4.5L3.5 0.888672H0V2.66699H13.999V0.888672ZM3.99805 13.334V5.33398H4.99805V13.334H3.99805ZM8.99805 5.33398V13.334H9.99805V5.33398H8.99805Z'
        fill='#8C97A2'
      />
    </svg>
  )
}

export default Exclude



// WEBPACK FOOTER //
// ./src/components/icons/vehicle/Exclude.tsx